export function BaseInput({
  value,
  onChange,
  placeholder = "",
  style = {},
  ...props
}) {
  return (
    <input
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      style={{
        fontSize: "16px",
        padding: "4px",
        boxSizing: "border-box",
        ...style
      }}
      {...props}
    />
  );
}
